module.exports = __webpack_public_path__ + "img/ppt-img.63175b72.png";